import React, { FC, useContext } from "react";

import { IWithRouteMatchProps } from "@/infrastructure/Route";
import { SessionContext } from "@/infrastructure/Session";
import { useRouter } from "@/router/useRouter";
import { PublicLayout } from "@/views/components/Layout";
import { router } from "@/views/router";

import { ClientNewsPage } from "./ClientNewsPage";
import { transformRouteProps } from "./selectors";

interface PublicClientNewsPageProps extends IWithRouteMatchProps {}

export const PublicClientNewsPage: FC<PublicClientNewsPageProps> = ({ ...props }) => {
  const { authenticated } = useContext(SessionContext);

  const { slug, newsId } = transformRouteProps(props);
  const { push } = useRouter<{}, {}>();

  if (authenticated) {
    push(router.get("client.news-detail", { slug, newsId }).path);
    return null;
  }

  return (
    <PublicLayout hideFooter={false} hideTopbar={false} borderBottomTopbar={false}>
      <ClientNewsPage isPublic {...props} />
    </PublicLayout>
  );
};
